import React, { useEffect } from 'react';
import { Col, Form, Row, Tooltip } from 'antd';
import { DataTable, FormField, InfoMessage, Select } from 'components';
import { useDispatch, useSelector } from 'react-redux';
import { omit, moment, get } from 'lodash';
import isEmpty from 'lodash/isEmpty';
import { ReactComponent as Info } from 'assets/icons/info-icon.svg';
import { formFieldsOther, formFieldsTourist } from './formFields';
import { useForm } from 'antd/lib/form/Form';
import { updateFormField } from 'store/forms/actions';

const SubTabPlan3 = () => {
  const dispatch = useDispatch();
    // const businessPlanDetails = useSelector(
    //   state => state.forms.businessPlanDetails
    // // );
  
  const [form] = useForm();
  const carrier = useSelector(state => state.forms.carrier);

  const viewMode = useSelector(state => state.forms.carrier?.viewMode);
  const activityField = useSelector(state => state.forms.carrier.activityField);

  const handleChange = ({ key, type, event }) => {
      let newValue;
      if (type === 'text' || type === 'textarea' || type === 'radio') {
        newValue = event.target.value;
      } else if (type === 'date') {
        newValue = new Date(event).toLocaleDateString("en-US");
      } else if (type === 'checkbox') {
        newValue = event.target.checked;
      } else if (
        type === 'select' ||
        type === 'number' ||
        type === 'numberWithDecimals' ||
        type === 'formattedNumber'
      ) {
        newValue = event;
      }

      dispatch(
            updateFormField({
              group: 'carrier',
              key,
              value: newValue,
            })
          );
  
    };

    const handleChangeSelect = ({ key, value }) => {
      
        const newValue = value ? value : null ;
    
        dispatch(
          updateFormField({
            group: 'carrier',
            key,
            value: newValue,
          })
        );

        dispatch(
          updateFormField({
            group: 'carrier',
            key: 'opMonths',
            value: null,
          })
        );
        dispatch(
          updateFormField({
            group: 'carrier',
            key:'roomsNum',
            value: null,
          })
        );
        dispatch(
          updateFormField({
            group: 'carrier',
            key:'complPerc',
            value: null,
          })
        );
        dispatch(
          updateFormField({
            group: 'carrier',
            key: 'roomsAvg',
            value: null,
          })
        );
        dispatch(
          updateFormField({
            group: 'carrier',
            key: 'estQuantity',
            value: null,
          })
        );
        dispatch(
          updateFormField({
            group: 'carrier',
            key: 'avgSalePrice',
            value: null,
          })
        );
      };

    useEffect(() => {
      form.setFieldsValue({
        activityField: carrier.activityField,
        opMonths: carrier.opMonths,
        roomsNum: carrier.roomsNum,
        complPerc: carrier.complPerc,
        roomsAvg: carrier.roomsAvg,
        estQuantity: carrier.estQuantity,
        avgSalePrice: carrier.avgSalePrice,
      });
    }, [form, carrier]);
  
    const renderFieldValue = field => {
      const value = get(carrier, field.name, '');
      return field.type === 'date' ? (value ? moment(value) : '') : value;
    };

  return (
    <div>
      <Form
        form={form}
        initialValues={
          {
            // ...carrier,
          }
        }
        trigger="onChange"
        className='basicInfoForm'
      >
        <div
          className="carrier-data-form"
          style={{ width: '90%', display: 'inline-block' }}
        >
        <p className="mt-4 mr-0 color-blue-3 text-bold font-size-24">
          Έσοδα Επένδυσης        
          </p>
           <Row
                  gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                  className="carrier-data-form__row"
                >
                  <Col className="gutter-row" span={24}>
                  Επιλέξτε τον τομέα δραστηριότητας στον οποίο ανήκει η επιχείρησή σας: <span style={{color:"#d45b2f"}}>*</span>
                    <Select
                      className="funding-select-wrapper"
                      disabled={viewMode}
                      id="funding"
                      title={''}
                      options={[
                        { value: 'tourist', label: 'Τουριστικός Τομέας', id:'tourist' },
                        { value: 'other', label: 'Άλλος Τομέας', id:'other' },
                      ]}
                      onChange={value => {
                        handleChangeSelect({ key: 'activityField', value });
                      }}
                      value={activityField}
                      placeholder={'Επιλέξτε Τομέα Δραστηριότητας'}
                    />
                  </Col>
                </Row>

        <Row
          gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
          className="carrier-data-form__row mt-3"
          align="top" >
          {activityField == "tourist" && formFieldsTourist.map((field, index) => {
            return (
              <Col key={index} className="gutter-row" span={field.span}>
                <Form.Item
                  name={[field.name]}
                  value={renderFieldValue(field)}
                  validateFirst
                  rules={field.rules}
                >
                  <FormField
                    key={index}
                    disabled={viewMode}
                    style={
                      viewMode
                        ? { pointerEvents: 'none', cursor: 'not-allowed' }
                        : {}
                    }
                    className={viewMode ? 'custom-checkbox-disabled' : ''}
                    {...omit(field, ['span', 'rules'])}
                    onChange={value =>
                      handleChange({
                        key: field.name,
                        type: field.type,
                        event: value,
                      })
                    }
                  />
                </Form.Item>
              </Col>
            );
          })}

          {activityField == "other" && formFieldsOther.map((field, index) => {
            return (
              <Col key={index} className="gutter-row" span={field.span}>
                <Form.Item
                  name={[field.name]}
                  value={renderFieldValue(field)}
                  validateFirst
                  rules={field.rules}
                >
                  <FormField
                    key={index}
                    disabled={viewMode}
                    style={
                      viewMode
                        ? { pointerEvents: 'none', cursor: 'not-allowed' }
                        : {textAlign: 'right'}
                    }
                    className={viewMode ? 'custom-checkbox-disabled' : ''}
                    {...omit(field, ['span', 'rules'])}
                    onChange={value =>
                      handleChange({
                        key: field.name,
                        type: field.type,
                        event: value,
                      })
                    }
                  />
                </Form.Item>
              </Col>
            );
          })}
        </Row>
        </div>
      </Form>
    </div>
  );
};

export default SubTabPlan3;
